
import {
  ADD_REPORT_ERROR, ADD_REPORT_REQUEST, ADD_REPORT_SUCCESS, INPUT_CHANGE, INPUT_ERROR,
  RESET_FORM
} from "./add-report-action-types";

export const inputChange = ({ inputValue, inputName }) => ({ type: INPUT_CHANGE, inputName, inputValue });
export const resetForm = () => ({ type: RESET_FORM });
export const inputError = ({ error, field }) => ({ type: INPUT_ERROR, error, field });

export const addReportRequest = () => ({ type: ADD_REPORT_REQUEST });
export const addReportError = () => ({ type: ADD_REPORT_ERROR });
export const addReportSuccess = () => ({ type: ADD_REPORT_SUCCESS });



// WEBPACK FOOTER //
// ./src/modules/add-report/add-report-action-creators.js